import React from 'react';
import { 
  MapPin, 
  Clock, 
  Mail, 
  Phone, 
  Facebook, 
  Instagram, 
  Info,
  ShieldCheck,
  FileText,
} from 'lucide-react';
import { FaWhatsapp } from "react-icons/fa6";
import { PiTiktokLogo, PiWhatsappLogo } from "react-icons/pi";

const Footer = () => {
  return (
    <footer className="relative bg-[#528a89] text-[#FFF5EE] overflow-hidden border-t-4 border-[#971253]">
      
      {/* --- DECORATIVE BACKGROUND ELEMENTS --- */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] border border-[#dbcdac]/10 rounded-full -translate-y-1/2 translate-x-1/3 pointer-events-none" />
      <div className="absolute top-0 right-0 w-[700px] h-[700px] border border-[#dbcdac]/5 rounded-full -translate-y-1/2 translate-x-1/3 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-[#971253]/20 to-transparent rounded-tr-full pointer-events-none opacity-40" />

      <div className="max-w-7xl mx-auto px-6 py-12 lg:pbe-16 pbs-6 relative z-10">
        
        {/* --- TOP ROW: BRAND BLOCK --- */}
        <div className="flex flex-col md:flex-row justify-center items-center md:items-center gap-6">
          

          {/* Warning Badge (Now a sleek horizontal pill) */}
          <div className="inline-flex items-center gap-3 px-5 py-3 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm shadow-sm">
            <Info size={18} className="text-[#dbcdac] shrink-0" />
            <span className="text-sm font-light tracking-wide text-[#FFF5EE]/90">
              Não trabalhamos com aluguel de jogos.
            </span>
          </div>

        </div>

        {/* --- DIVIDER --- */}
        <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#dbcdac]/40 to-transparent my-10" />
        
        {/* --- 3-COLUMN GRID --- */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          
          {/* COLUMN 1: ATENDIMENTO */}
          <div className="space-y-10"> {/* Espaçamento maior entre os blocos para respirar */}
  
  {/* Sub-bloco: Atendimento */}
        <div className="space-y-5">
            <h3 className="font-serif text-xl text-[#dbcdac]">Atendimento</h3>
            <ul className="space-y-4 p-0">
            <li>
                <a href="mailto:delidapersy@gmail.com" className="group flex items-center gap-3 text-sm text-[#FFF5EE]/80 hover:text-[#dbcdac] transition-colors">
                <Mail size={16} className="text-[#dbcdac]/70 group-hover:text-[#dbcdac] transition-colors" />
                <span className="font-light tracking-wide">delidapersy@gmail.com</span>
                </a>
            </li>
            <li>
                <a href="https://wa.me/558821577839" target="_blank" rel="noreferrer" className="group flex items-center gap-3 text-sm text-[#FFF5EE]/80 hover:text-[#dbcdac] transition-colors">
                <Phone size={16} className="text-[#dbcdac]/70 group-hover:text-[#dbcdac] transition-colors" />
                <span className="font-light tracking-wide">(88) 2157-7839</span>
                </a>
            </li>
            </ul>
        </div>

        {/* Sub-bloco: Políticas e Segurança */}
        <div className="space-y-5">
            <h3 className="font-serif text-xl text-[#dbcdac]">Segurança</h3>
            <ul className="space-y-4 p-0">
            <li>
                <a href="/politica-de-privacidade" className="group flex items-center gap-3 text-sm text-[#FFF5EE]/80 hover:text-[#dbcdac] transition-colors">
                <ShieldCheck size={16} className="text-[#dbcdac]/70 group-hover:text-[#dbcdac] transition-colors" />
                <span className="font-light tracking-wide">Política de Privacidade</span>
                </a>
            </li>
            <li>
                <a href="/termos-de-uso" className="group flex items-center gap-3 text-sm text-[#FFF5EE]/80 hover:text-[#dbcdac] transition-colors">
                <FileText size={16} className="text-[#dbcdac]/70 group-hover:text-[#dbcdac] transition-colors" />
                <span className="font-light tracking-wide">Termos de Uso</span>
                </a>
            </li>
            </ul>
        </div>

        </div>

          {/* COLUMN 2: REDES SOCIAIS */}
          <div className="space-y-5">
            <h3 className="font-serif text-xl text-[#dbcdac]">Siga a Deli</h3>
            <p className="text-[#FFF5EE]/70 font-light text-sm mb-4 leading-relaxed pr-4">
              Acompanhe nossos eventos, novidades no cardápio e novos jogos no acervo.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/DeliDaPersy" 
                target="_blank" 
                rel="noreferrer"
                className="p-2.5 rounded-full bg-[#FFF5EE]/10 text-[#FFF5EE] hover:bg-[#971253] hover:text-white hover:-translate-y-1 hover:shadow-lg hover:shadow-[#971253]/30 transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="https://www.instagram.com/delidapersy/" 
                target="_blank" 
                rel="noreferrer"
                className="p-2.5 rounded-full bg-[#FFF5EE]/10 text-[#FFF5EE] hover:bg-[#971253] hover:text-white hover:-translate-y-1 hover:shadow-lg hover:shadow-[#971253]/30 transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a href="https://tiktok.com/@delidapersy"
               target="_blank"
                rel="noreferrer"
                 className="p-2.5 rounded-full bg-[#FFF5EE]/10 text-[#FFF5EE] hover:bg-[#971253] hover:text-white hover:-translate-y-1 hover:shadow-lg hover:shadow-[#971253]/30 transition-all duration-300"
                 aria-label="TikTok"
              >
                <PiTiktokLogo size={18} />
              </a>
              <a href="https://wa.me/558821577839"
               target="_blank"
                rel="noreferrer"
                 className="p-2.5 rounded-full bg-[#FFF5EE]/10 text-[#FFF5EE] hover:bg-[#971253] hover:text-white hover:-translate-y-1 hover:shadow-lg hover:shadow-[#971253]/30 transition-all duration-300"
                 aria-label="Whatsapp"
              >
                <PiWhatsappLogo size={18} />
              </a>
            </div>
          </div>

          {/* COLUMN 3: LOCALIZAÇÃO E HORÁRIOS */}
          <div className="space-y-6">
            
            {/* Location Section */}
            <div className="space-y-3">
              <h3 className="font-serif text-xl text-[#dbcdac] flex items-center gap-2">
                <MapPin size={18} /> Localização
              </h3>
              <a 
                href="https://maps.app.goo.gl/AWw1kGBnorwdGc9B9" 
                target="_blank" 
                rel="noreferrer"
                className="block text-[#FFF5EE]/80 text-sm font-light hover:text-[#dbcdac] transition-colors leading-relaxed"
              >
                Rua Padre Cícero, 905 A<br/>
                Juazeiro do Norte - CE<br/>
                63010-021
              </a>
            </div>

            {/* Subtle Gradient Divider */}
            <div className="h-[1px] w-full bg-gradient-to-r from-[#dbcdac]/30 to-transparent" />

            {/* Hours Section */}
            <div className="space-y-3">
              <h3 className="font-serif text-xl text-[#dbcdac] flex items-center gap-2">
                <Clock size={18} /> Horário
              </h3>
              <ul className="text-[#FFF5EE]/80 font-light space-y-1.5 p-0 text-sm">
                <li className="flex justify-between items-center">
                  <span className="font-medium text-[#FFF5EE] shrink-0">Sextas</span> 
                  <span className="flex-grow border-b border-dashed border-[#FFF5EE]/20 mx-3"></span>
                  <span className="shrink-0 text-right">18:00 - 00:00</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="font-medium text-[#FFF5EE] shrink-0">Sábados</span> 
                  <span className="flex-grow border-b border-dashed border-[#FFF5EE]/20 mx-3"></span>
                  <span className="shrink-0 text-right">16:00 - 00:00</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="font-medium text-[#FFF5EE] shrink-0">Domingos</span> 
                  <span className="flex-grow border-b border-dashed border-[#FFF5EE]/20 mx-3"></span>
                  <span className="shrink-0 text-right">16:00 - 22:00</span>
                </li>
              </ul>
            </div>

          </div>

        </div>

        {/* --- BOTTOM COPYRIGHT BAR --- */}
        <div className="mt-16 pt-6 border-t border-[#FFF5EE]/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-light text-[#FFF5EE]/50">
          <p>© {new Date().getFullYear()} Deli da Persy. Todos os direitos reservados.</p>
          <p className="flex items-center gap-1.5">
            Feito com magia no Cariri
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;